webpackJsonp([15263498413233],{

/***/ 927:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"title":"Taiwan coffee chain 85°C kowtows to China after Chinese netzens threaten boycott","createdAt":"8 hours ago","by":"electriclove","comments":[{"text":"It&#x27;s worth keeping in mind that PRC seems to have large astro-turf farms. You can see it here on HN: comments about PRC and Taiwan on HN get modded up or down in the usual first 1 or 2 hours of a post, then PRC gets involved and suddenly anything pro democracy, supporting Hong Kong, or even mentioning the official name of Taiwan is suddenly moderated to death.<p>I wouldn&#x27;t be surprised if a lot of people initially angry about 85 degrees serving the Taiwanese PM are paid to be so, before a lot of real people get in on the outrage machine.","by":"nailer","timeISO":"an hour ago"}]}}

/***/ })

});


// WEBPACK FOOTER //
// path---comment-17771962-5ccbd58dcddc77e554cc.js